import type { NewsletterSignupComponent } from "../../types";

/** Newsletter signup form renderer with consent checkbox. */
export function NewsletterSignupRenderer({ component }: { component: NewsletterSignupComponent }) {
  const { title, description, consentLabel, emailPlaceholder, requiredNote, submitLabel } = component.content;

  return (
    <section className="mx-[calc(50%-50vw)] bg-[#008ED8] text-white mt-16 pt-10 pb-10 -mb-16 md:-mb-16">
      <div className="mx-auto w-full max-w-4xl px-5 md:px-8">
        <div className="space-y-4 rounded-xl  p-5  md:p-8">
          <div>
            <p className="text-2xl font-semibold leading-snug" style={{ fontFamily: "Aleo" }}>
              {title}
            </p>
            {description ? <p className="mt-2 text-sm xl:text-base md:text-base text-white/90">{description}</p> : null}
          </div>
          <label className="flex items-start gap-2 text-sm xl:text-base text-white/90">
            <input
              type="checkbox"
              className="mt-1 h-4 w-4 rounded  bg-transparent text-[#FFA401] focus:ring-[#FFA401]"
            />
            <span>{consentLabel}</span>
          </label>
          <div className="space-y-1">
            <input
              type="email"
              className="h-12 w-full rounded border  bg-white/15 px-4 text-base xl:text-lg text-white placeholder-white/70 focus:border-white focus:outline-none focus:ring-1 focus:ring-white"
              placeholder={emailPlaceholder}
            />
            {requiredNote ? <p className="text-xs xl:text-sm text-white/70">{requiredNote}</p> : null}
          </div>
          <button className="inline-flex items-center gap-2 rounded-full bg-[#FFA401] px-6 py-2 text-sm xl:text-base font-semibold text-white transition hover:bg-[#ff9200]">
            {submitLabel}
        <span aria-hidden="true">›</span>
          </button>
        </div>
      </div>
    </section>
  );
}

